export const isInjuredOptions = [
  {
    id: true,
    value: true,
    label: 'Injured',
  },
  {
    id: false,
    value: false,
    label: 'Not Injured',
  },
];
